<template>
  <zen-one  :title="'Welcome to ' ">




  </zen-one>
</template>

<script>

import ZenOne from '@/Shared/ZenOne'
import Vue3ChartJs from '@j-t-mcc/vue3-chartjs'

export default {
components: {
  Vue3ChartJs,
  ZenOne
},
  setup () {
    const doughnutChart = {
      id: 'doughnut',
      type: 'doughnut',
      data: {
        labels: ['VueJs', 'EmberJs', 'ReactJs', 'AngularJs'],
        datasets: [
          {
            backgroundColor: [
              '#37479e',
              '#2f3d88',
              '#273371',
              '#1f285a'
            ],
            data: [40, 20, 80, 10]
          }
        ]
      },
      options: { plugins: { legend: { display: false }, } }

    }

    const beforeRenderLogic = (event) => {
      //...
      //if(a === b) {
      //  event.preventDefault()
      //}
    }

    return {
      doughnutChart,
      beforeRenderLogic
    }
  },
data() {
    return {
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
  crumbs: [
    {label: this.$page.props.app_name, route: '/home'}
  ],
  showCard: false,
}},
methods: {
  onSuccess () {
    setTimeout(() => (this.form.sent = true), 2000)
  },
  onValidate () {
    this.form.sent = false
    this.form.submitted = this.form.errorsCount === 0
  }
},
mounted() {
    
    this.params = location.search.slice(1).split('&').map(p => p.split('=')).reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
    if(this.params.l == 1){
      window.location.replace(window.location.pathname);
    }
}
}

</script>

<style>


</style>
